import { ButtonBase } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

type Props = {
  side: 'left' | 'right';
  onClick: () => void;
};

const Arrow = ({ side, onClick }: Props) => {
  const isLeft = side === 'left';
  return (
    <ButtonBase
      onClick={onClick}
      focusRipple={true}
      aria-label={isLeft ? 'previous image' : 'next image'}
      sx={{
        position: 'absolute',
        top: 0,
        zIndex: 8,
        width: '80px',
        height: '100%',
        left: isLeft ? 0 : undefined,
        right: !isLeft ? 0 : undefined,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        stroke: 'black',
      }}
    >
      {isLeft ? <ArrowBackIosIcon /> : <ArrowForwardIosIcon />}
    </ButtonBase>
  );
};

export default Arrow;
